import script from "./CtaEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaEditor.vue?vue&type=script&setup=true&lang=js"

import "./CtaEditor.vue?vue&type=style&index=0&id=7717f64c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7717f64c"]])

export default __exports__